import { useCallback, useEffect, useState } from 'react';
import { Modal } from 'antd';

const CURRENT_VERSION = import.meta.env.VITE_APP_VERSION;
const VERSION_CHECK_ENABLED =
  import.meta.env.VITE_ENABLE_VERSION_CHECK === 'true';
const DEFAULT_CHECK_INTERVAL = 300000;
const VERSION_CHECK_INTERVAL =
  Number(import.meta.env.VITE_VERSION_CHECK_INTERVAL) ||
  DEFAULT_CHECK_INTERVAL;

// 渲染版本更新提示按钮，并在检测到新版本时提醒用户刷新
export default function VersionUpdateButton() {
  const [latestVersion, setLatestVersion] = useState('');

  // 带上最新版本参数刷新页面，降低命中旧入口文件缓存的概率
  const refreshToLatestVersion = useCallback(() => {
    const url = new URL(window.location.href);
    url.searchParams.set('_v', latestVersion);
    window.location.replace(url.toString());
  }, [latestVersion]);

  // 二次确认用户已经保存当前页面内容后再更新版本
  const confirmUpdate = useCallback(() => {
    Modal.confirm({
      title: '确认更新版本？',
      content: '刷新页面会清空当前未保存的表单内容，请先保存后再更新。',
      okText: '已保存，立即更新',
      cancelText: '稍后再说',
      onOk: refreshToLatestVersion,
    });
  }, [refreshToLatestVersion]);

  // 启动版本轮询，组件卸载时清理定时器
  useEffect(() => {
    if (!VERSION_CHECK_ENABLED || !CURRENT_VERSION) {
      return undefined;
    }

    let isMounted = true;

    // 请求远端版本文件，并和当前页面内置版本做对比
    const checkVersion = async () => {
      try {
        const response = await fetch(`/version.json?t=${Date.now()}`, {
          cache: 'no-store',
        });

        if (!response.ok) {
          return;
        }

        const data = await response.json();
        const remoteVersion = data?.version;

        if (isMounted && remoteVersion && remoteVersion !== CURRENT_VERSION) {
          setLatestVersion(remoteVersion);
        }
      } catch (error) {
        console.warn('版本检测失败', error);
      }
    };

    checkVersion();
    const timer = window.setInterval(checkVersion, VERSION_CHECK_INTERVAL);

    return () => {
      isMounted = false;
      window.clearInterval(timer);
    };
  }, []);

  if (!VERSION_CHECK_ENABLED || !latestVersion) {
    return null;
  }

  return (
    <button
      type="button"
      className="inline-flex items-center rounded-md bg-blue-50 px-3 py-1.5 text-sm font-medium text-blue-600 hover:bg-blue-100 transition-colors duration-150 cursor-pointer"
      onClick={confirmUpdate}
    >
      发现新版本，点击更新
    </button>
  );
}
